// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="bg-black text-white border-t border-gray-800">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//         <div className="grid grid-cols-1 md:grid-cols-10 gap-8">
//           {/* Logo and Social */}
//           <div className="md:col-span-3">
//             <div className="flex items-center mb-4">
//               <span className="text-2xl font-bold text-white">First International College</span>
//             </div>
//             <p className="text-gray-300 text-sm mb-6">
//               Empowering students through quality education and innovative learning experiences.
//             </p>
//             <div className="flex space-x-4">
//               {[
//                 { 
//                   icon: <FaFacebook style={{ color: 'white' }} className="w-5 h-5" />, 
//                   url: 'https://facebook.com/lawrencecollege',
//                   label: 'Facebook'
//                 },
//                 { 
//                   icon: <FaTwitter style={{ color: 'white' }} className="w-5 h-5" />, 
//                   url: 'https://twitter.com/lawrencecollege',
//                   label: 'Twitter'
//                 },
//                 { 
//                   icon: <FaLinkedin style={{ color: 'white' }} className="w-5 h-5" />, 
//                   url: 'https://linkedin.com/school/lawrencecollege',
//                   label: 'LinkedIn'
//                 },
//                 { 
//                   icon: <FaInstagram style={{ color: 'white' }} className="w-5 h-5" />, 
//                   url: 'https://instagram.com/lawrencecollege',
//                   label: 'Instagram'
//                 },
//                 { 
//                   icon: <FaYoutube style={{ color: 'white' }} className="w-5 h-5" />, 
//                   url: 'https://youtube.com/@firstinternationalconsultants?si=Sy5Dd5UAAkA60VBY',
//                   label: 'YouTube'
//                 }
//               ].map((social, index) => (
//                 <a 
//                   key={index}
//                   href={social.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-white hover:opacity-75 transition-opacity"
//                   aria-label={social.label}
//                 >
//                   {social.icon}
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div className="md:col-span-2">
//             <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h3>
//             <ul className="space-y-2">
//               {[
//                 'Home', 
//                 'About', 
//                 'Academics', 
//                 'University Progression', 
//                 'Our Campus', 
//                 'Centers', 
//                 'Contact', 
//                 'Apply Now'
//               ].map((item, index) => (
//                 <li key={index}>
//                   <Link 
//                     to={item === 'Apply Now' ? '/apply-form' : `/${item.toLowerCase().replace(/\s+/g, '-')}`}
//                     className="text-sm !text-white hover:opacity-75 transition-opacity block py-1"
//                   >
//                     {item}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Opening Hours */}
//           <div className="md:col-span-2">
//             <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Opening Hours</h3>
//             <ul className="space-y-2">
//               {[
//                 { day: 'Monday - Friday', time: '8:00 AM - 5:00 PM' },
//                 { day: 'Saturday', time: '9:00 AM - 2:00 PM' },
//                 { day: 'Sunday', time: 'Closed' },
//                 { day: 'Public Holidays', time: 'Closed' }
//               ].map((item, index) => (
//                 <li key={index} className="text-sm text-white">
//                   <div className="font-medium">{item.day}</div>
//                   <div className="text-white/80">{item.time}</div>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Contact */}
//           <div className="md:col-span-3">
//             <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Contact Us</h3>
//             <address className="not-italic space-y-2">
//               <p className="text-sm text-white">123 Education Street</p>
//               <p className="text-sm text-white">2nd Floor, FIC Plaza, Adjacent Savour Food, Bahria Town Phase 7, Islamabad</p>
//               <p className="text-sm">
//                 <a href="tel:+923008744261" className="!text-white hover:opacity-75 transition-opacity">
//                  +923008744261
//                 </a>
//               </p>
//               <p className="text-sm">
//                 <a href="mailto:info@FIC.edu" className="!text-white hover:opacity-75 transition-opacity">
//                   info@FIC.edu
//                 </a>
//               </p>
//             </address>
//           </div>
//         </div>

//         {/* Divider */}
//         <div className="border-t border-gray-800 my-8"></div>

//         {/* Copyright and Legal */}
//         <div className="flex flex-col md:flex-row justify-between items-center">
//           <p className="text-xs text-white/80 mb-4 md:mb-0">
//             &copy; {currentYear} First International College. All rights reserved.
//           </p>
//           <div className="flex space-x-6">
//             {['Privacy Policy', 'Terms of Service', 'Sitemap'].map((item, index) => (
//               <Link 
//                 key={index}
//                 to={`/${item.toLowerCase().replace(' ', '-')}`} 
//                 className="text-xs !text-white hover:opacity-75 transition-opacity"
//               >
//                 {item}
//               </Link>
//             ))}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaInstagram, 
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope
} from 'react-icons/fa';

// Placeholder Logo Component, replace with your actual Logo if you have one
const FooterLogo = () => (
  <span className="text-3xl font-extrabold text-white tracking-tight">
    First International College
  </span>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Data arrays for clean mapping
  const quickLinks = {
    academics: [
      { title: 'Academics', path: '/academics' },
      { title: 'Business & Management', path: '/academics/business-management' },
      { title: 'Health & Social Care', path: '/academics/health-social-care' },
      { title: 'Information Technology', path: '/academics/information-technology' },
    ],
    resources: [
      { title: 'University Progression', path: '/university-progression' },
      { title: 'Our Campus', path: '/online-campus' },
      { title: 'Centers', path: '/centers' },
      { title: 'Apply Now', path: '/apply-form' },
    ],
    about: [
      { title: 'About Us', path: '/about' },
      { title: 'Contact Us', path: '/contact' },
      { title: 'FAQ', path: '/faq' }, // Added for completeness
    ]
  };

  const socialMedia = [
    { icon: <FaFacebookF />, url: 'https://facebook.com/ficgroupedu', label: 'Facebook', color: 'hover:bg-blue-600' },
    { icon: <FaTwitter />, url: 'https://twitter.com/ficgroupedu', label: 'Twitter', color: 'hover:bg-sky-500' },
    { icon: <FaLinkedinIn />, url: 'https://linkedin.com/school/ficgroupedu', label: 'LinkedIn', color: 'hover:bg-blue-700' },
    { icon: <FaInstagram />, url: 'https://instagram.com/ficgroupedu', label: 'Instagram', color: 'hover:bg-pink-600' },
    { icon: <FaYoutube />, url: 'https://youtube.com/@firstinternationalconsultants?si=Sy5Dd5UAAkA60VBY', label: 'YouTube', color: 'hover:bg-red-600' }
  ];

  return (
    <footer className="bg-gradient-to-t from-[#111] to-black text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* === Section 1: Centered Brand and Newsletter === */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <FooterLogo />
          </div>
          <p className="max-w-md mx-auto text-gray-400 mb-6">
            Stay updated with our latest news, events, and academic offerings.
          </p>
          <form className="max-w-sm mx-auto flex">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full bg-gray-800 border border-gray-700 text-white px-4 py-2.5 rounded-l-md focus:ring-2 focus:ring-primary focus:outline-none"
              required
            />
            <button
              type="submit"
              className="bg-primary hover:bg-primary-dark text-white font-bold px-6 py-2.5 rounded-r-md transition-colors"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* === Section 2: Organized Sitemap Grid === */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Column 1: Academics */}
          <div>
            <h3 className="font-semibold text-white uppercase tracking-wider mb-4">Academics</h3>
            <ul className="space-y-2">
              {quickLinks.academics.map(link => (
                <li key={link.title}>
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:pl-1 transition-all">
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Column 2: Resources */}
          <div>
            <h3 className="font-semibold text-white uppercase tracking-wider mb-4">Resources</h3>
            <ul className="space-y-2">
              {quickLinks.resources.map(link => (
                <li key={link.title}>
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:pl-1 transition-all">
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Column 3: About */}
          <div>
            <h3 className="font-semibold text-white uppercase tracking-wider mb-4">About</h3>
            <ul className="space-y-2">
              {quickLinks.about.map(link => (
                <li key={link.title}>
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:pl-1 transition-all">
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Column 4: Contact Info */}
          <div>
            <h3 className="font-semibold text-white uppercase tracking-wider mb-4">Get In Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaMapMarkerAlt className="w-4 h-4 mt-1 mr-3 text-gray-500 flex-shrink-0" />
                <span className="text-gray-400">2nd Floor, FIC Plaza, Bahria Town Phase 7, Islamabad</span>
              </li>
              <li className="flex items-center">
                <FaPhoneAlt className="w-4 h-4 mr-3 text-gray-500 flex-shrink-0" />
                <a href="tel:+923008744261" className="text-gray-400 hover:text-white transition-colors">
                  +92 300 8744261
                </a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="w-4 h-4 mr-3 text-gray-500 flex-shrink-0" />
                <a href="mailto:info@ficgroupedu.com" className="text-gray-400 hover:text-white transition-colors">
                  info@ficgroupedu.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* === Section 3: Bottom Bar with Copyright & Social Icons === */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-gray-500 text-center md:text-left">
            © {currentYear} First International College. All rights reserved.
          </p>
          <div className="flex space-x-3">
            {socialMedia.map(social => (
              <a 
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className={`w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 text-white ${social.color} transition-colors duration-300`}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
